import { render } from "./ComplaintDetDialog.vue?vue&type=template&id=3acce47c"
import script from "./ComplaintDetDialog.vue?vue&type=script&lang=js"
export * from "./ComplaintDetDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\LifeInsureance\\web\\LifeInsurance\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__